import { useEffect, useState } from "react";

function useGlobalState(globalState) {
  const [, setFakeState] = useState();
  const state = globalState.getValue();

  function reRender(newState) {
    setFakeState(newState);
  }

  useEffect(() => {
    globalState.subscribe(reRender);

    return () => {
      globalState.unsubscribe(reRender);
    };
  });

  function setState(newState) {
    globalState.setValue(newState);
  }

  return [state, setState];
}

export default useGlobalState;
